import { api } from './client'
import { withCustomerIds } from './params'

/** Active open alerts (newest first). */
export function fetchRecentAlerts(limit = 8, customerIds = []) {
  return api
    .get('/alerts', {
      params: withCustomerIds({ limit, active_only: true }, customerIds),
    })
    .then((r) => r.data)
}
